export const calculateLoadedPercent = (loaded: number, total: number) => {
  return Math.floor((loaded * 100) / total);
};
